<template>
  <DBox
    :id="'cmp-distribution-shops-sidewindow-shop_translations'"
    :addButton="false"
  >
    <NTable
      class="dbox1"
      id="distribution-shops-sidewindow-shop_translations-list"
      :config="tableConfig"
      :headers="headers"
      :items="selectedShopDetails.related_translations || []"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('translations')">
            <span :title="item['imported_name']">
              {{ item["imported_name"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedShopDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        // createTableHeader("shop_group_name", {
        //   text: `${this.$t("tab_title_shop_groups")}`
        // }),
        createTableHeader("translations")
      ];
    }
  }
};
</script>
